import * as PIXI from "pixi.js-legacy";
import {injectable} from "inversify";

interface IGrelem {
    add(name, grelem);
    get(name);
    remove(name);
    destroy(name, params)
}

@injectable()
class MadmaxPixiLayer extends PIXI.Container {

    protected _grelems: Record<string, any>;
    protected _layers: Record<string, MadmaxPixiLayer>;
    protected grelem: IGrelem;

    constructor() {
        super();

        this._grelems = {};
        this._layers = {};

        this.grelem = {
            add: (name, grelem) => this.addGrelem(name, grelem),
            get: name =>  this.getGrelem(name),
            remove: name => this.removeGrelem(name),
            destroy: (name, params) => this.destroyGrelem(name, params)
        };
    }

    /**
     *
     * @param {string} name
     * @return {PIXI.Sprite}
     */
    getGrelem(name) {
        return this._grelems[name];
    }

    /**
     *
     * @param {string} name
     * @param {PIXI.DisplayObject} grelem
     */
    addGrelem(name, grelem) {
        grelem.name = name;
        this._grelems[name] = grelem;
        // @ts-ignore
        this.addChild(grelem);
        return this._grelems[name];
    }

    removeGrelem(name) {
        // @ts-ignore
        this.removeChild(this._grelems[name]);
        delete this._grelems[name];
    }

    /**
     * http://www.html5gamedevs.com/topic/30539-correct-way-to-remove-sprites-container/
     */
    destroyGrelem(name, { children = true, texture = true, baseTexture = true}) {
        // @ts-ignore
        this.destroy(this._grelems[name], { children , texture, baseTexture});
        delete this._grelems[name];
    }

    addLayer(name: string, layer: MadmaxPixiLayer) {
        // @ts-ignore
        layer.name = name;
        this._layers[name] = layer;
        // @ts-ignore
        this.addChild(layer);
        return this._layers[name];
    }

    getLayer(name) {

        let dotPos = name.indexOf(".");
        if(dotPos != -1) {
            let current = name.slice(0, dotPos);
            let next = name.slice(dotPos + 1);

            return this._layers[current].getLayer(next);
        }

        return this._layers[name];
    }

    /**
     *
     * @param {string} name
     */
    addLayerToTop(name) {
        this.addLayer(name, this.getLayer(name));
    }

    /**
     *
     * @return {Object<MadmaxPixiLayer>}
     */
    getAllLayers() {
        return this._layers;
    }
}

export default MadmaxPixiLayer;